<!-- eslint-disable no-duplicate-case -->
<template>
  <div class="order-list-wrap">
    <ul>
      <li
        :class="['list-wrap', currentIndex === index ? 'active' : '']"
        v-for="(item, index) in orderListData"
        :key="item.id"
        @click="setCurrentIndex(item, index)"
      >
        <div class="order-list-detail-wrap">
          <p class="list-status-wrap flex">
            <span class="time">{{ item.createTime }}</span>
            <em class="status">{{ item.orderStatusTitle }}</em>
          </p>
          <div class="car-type-wrap flex">
            <h5>{{ item.carModelName }}</h5>
            <span
              class="car-tag"
              v-if="
                showEstimatedDeliveryDateTag(item.status) === 'true' &&
                  (item.appointmentDeliveryDate || item.estimatedDeliveryDate)
              "
            >
              预计
              {{
                item.appointmentDeliveryDate ||
                  item.estimatedDeliveryDate ||
                  "-"
              }}
              前交付
            </span>
          </div>
          <div class="version-wrap">{{ item.carModelVersionName }}</div>
          <div class="price-wrap">
            购车总价：¥{{ item.subsidyTotalPrice.toLocaleString() }}
          </div>
          <p class="car-detail-wrap">
            <span>{{ item.carConfigDetailData }} </span>
          </p>
        </div>
        <div
          class="order-list-floor "
          v-if="item.status === 20 || item.status === 21"
        >
          <div v-if="item.status === 21" class="order-order-played-wrap">
            <span>已支付</span>
            <span>¥{{ item.paidPrice.toLocaleString() }}</span>
          </div>
          <div
            class="order-order-play-btns"
            @click="handleShowPapDialog($event, item)"
          >
            <div class="order-order-play-btn" v-if="item.status === 20">
              待支付¥ {{ item.payMoney.toLocaleString() }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getDevice } from "@utils/device";

export default {
  name: "orderList",
  components: {},
  props: {
    orderListData: {
      type: Array,
    },
    orderStatusEnu: {
      type: Object,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    showEstimatedDeliveryDateTag() {
      return function(status) {
        switch (status) {
          case 20: //定金已支付（订单确认中）
          case 3: //已支付（意向金已支付）
            return "true";
          default:
            return "false";
        }
      };
    },
  },
  mounted() {},
  methods: {
    setCurrentIndex(item, index) {
      console.log("id切换", item.id);
      const device = getDevice();
      if (device != "PC") {
        window.location.href = `./orderDetail.html?orderId=${item.id}`;
      } else {
        this.currentIndex = index;
        this.$emit("changeOrderId", item.id);
      }
    },
    handleShowPapDialog(ev, item) {
      console.log("show");
      ev.stopPropagation();
      this.$emit("handleShowPapDialog", {
        showPayDialog: true,
        orderId: item.id,
      });
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
* {
  margin: 0;
  font-style: normal;
}
html,
body {
  background: #fff;
}

//订单列表
.order-list-wrap {
  font-family: PingFang SC;
  @include media(
    (
      $home-lg: (),
      $home-bg: (),
      $home-md: (
        width: 100%,
      ),
      $home-sm: (),
    )
  );
  .flex {
    display: flex;
    justify-content: space-between;
  }
  .list-wrap {
    padding: 15px;
    width: 400px;
    border: 1px solid #eee;
    margin-bottom: 20px;
    border-radius: 8px;
    cursor: pointer;
    &.active {
      border: 1px solid #00b9ef;
      @include media(
        (
          $home-lg: (),
          $home-bg: (),
          $home-md: (
            border: 1px solid #eee,
          ),
          $home-sm: (
            border: 1px solid #eee,
          ),
        )
      );
    }

    @include media(
      (
        $home-lg: (),
        $home-bg: (),
        $home-md: (
          width: 100%,
        ),
        $home-sm: (),
      )
    );
    @media (max-width: 1439px) {
      width: 100%;
    }
    // .order-list-detail-wrap {
    //   border-bottom: 1px solid #eee;
    // }
    .list-status-wrap {
      font-family: PingFang SC;
      font-style: normal;
      letter-spacing: 0.5px;
      font-weight: 400;
      padding-bottom: 15.5px;
      .time {
        font-size: 12px;
        line-height: 19px;
      }
      .status {
        font-size: 14px;
        line-height: 22px;
        font-style: normal;
      }
    }
    .car-type-wrap {
      h5 {
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 25px;
        letter-spacing: 0.5px;
        color: #000;
      }
      .car-tag {
        font-size: 12px;
        font-weight: 500;
        line-height: 19px;
        color: #00b9ef;
        padding: 2px 15px;
        border-radius: 62px;
        background: #e6f8fd;
      }
    }
    .version-wrap {
      font-size: 14px;

      line-height: 24px;
      color: #000;
      padding-bottom: 5px;
    }
    .price-wrap {
      font-size: 14px;
      font-style: normal;
      line-height: 24px;
      color: #000;
      padding-bottom: 20px;
    }
    .car-detail-wrap {
      padding-bottom: 17px;
      span {
        font-size: 11px;
        line-height: 19px;
        color: #4c4f59;
      }
    }
    .order-list-floor {
      padding-top: 12px;
      border-top: 1px solid #eee;
      .order-order-played-wrap {
        display: flex;
        justify-content: space-between;
      }
      .order-order-play-btns {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .order-order-play-btn {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          width: 136px;
          height: 40px;
          padding: 8px 0px;
          background: #131415;
          text-align: center;
          color: #fff;
          border-radius: 71px;
        }
      }
    }
  }
}
</style>
